(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name documentManager.service:documentManagerService
     *
     * @description
     *
     */
    angular
        .module('documentManager')
        .service('DocumentManagerService', DocumentManagerService);
    
    function DocumentManagerService(DocumentManagerRequestFactory, RemoteService, DocumentManagerAdaptorFactory, $sce,$window) {
        var self = this,
            model={
                documentSearchCriteria: DocumentManagerRequestFactory.getDocumentSearchRequest(),
                documentList:[]
            };

        self.setSearchCriteria = function (searchParams) {
            var docSearchCriteria = DocumentManagerRequestFactory.getDocumentSearchRequest();
            docSearchCriteria.startPosition = searchParams.startPosition;
            docSearchCriteria.pageSize = searchParams.pageSize;
            if(searchParams.crewType.crewTypeCode==="ANY"){
                docSearchCriteria.crewTypeCode = null;
            }else{
                docSearchCriteria.crewTypeCode = [searchParams.crewType.crewTypeCode];
            }
            if(!!searchParams.category && searchParams.category!==null){
                docSearchCriteria.categoryCode = searchParams.category.categoryCode;
            }else{
                docSearchCriteria.categoryCode = null;
            }
            model.documentSearchCriteria = docSearchCriteria;
        };

        self.getSearchCriteria = function () {
            return model.documentSearchCriteria;
        };

        self.getDocumentEditOptions = function(id, mode, selectedItems, masterLists, submitCallBack, fieldChangeCallBack){
            var editOptions = DocumentManagerRequestFactory.getEditOptions();
                editOptions.id = id;
                editOptions.mode = mode;
                editOptions.selectedItem = selectedItems;
                editOptions.masterList = masterLists;
                editOptions.submitCallBack = submitCallBack;
                editOptions.changeFieldsCallBack = fieldChangeCallBack;
            return editOptions;
        };

        self.getDocUploadRequest = function () {
            return DocumentManagerRequestFactory.getDocumentUploadRequest();
        };

        self.getDocDisplayInGrid = function (doc){
            var temp = DocumentManagerRequestFactory.getDocumentUploadRequest();
            if(!angular.isUndefined(doc)){
                temp.categoryCode = doc.categoryCode;
                temp.category = {
                    categoryCode:doc.categoryCode,
                    categoryDesc:doc.categoryDesc
                };
                temp.crewProfileIds= doc.crewProfileList
                /*_.each(doc.crewProfileList, function (items){
                    temp.crewProfileIds.push({crewProfileId : items.crewProfileId, crewName: items.crewName})
                });*/
                temp.crewType = doc.crewTypesList;
                temp.crewTypeCode = doc.crewTypesList;
                temp.downloadId = doc.downloadID;
                temp.filePath = doc.filePath;
                temp.status = !doc.status;
                temp.summary = doc.summary;
                temp.title = doc.title;
                temp.validUntilDate = doc.validDateUntil;
                temp.version = doc.version;
                temp.lastModified = moment(doc.dateUploaded).format('DD/MM/YYYY');
                temp.file = {name :doc.filePath};
            }else{
                temp.title = 'Untitled';
//                temp.category = {
//                    categoryCode:null,
//                    categoryDesc: 'Not Set'
//                };
                temp.lastModified = moment().format('DD/MM/YYYY');
            }
            temp.inlineEditOptions = null;
            temp.actionFlag = false;
            temp.activeFlag=false;
            return temp;
        };

        self.searchDocuments = function(params, successFn, errorFn){
            params.status = 'ACT';
            RemoteService.loadDocuments(params).then(
                function (response) {
                    if(response.success && !!response.downloadDocumentList){
                        model.documentList = response.downloadDocumentList;
                        successFn(model.documentList);
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        };
        
        self.submitDocumentForm = function (formData, formFieldJson, successFn, errorFn) {
            var adaptedFormData = DocumentManagerAdaptorFactory.adaptFormSubmit(formData, formFieldJson);
            RemoteService.submitAsFormRequest('documentManageUpload', adaptedFormData, successFn, errorFn);
        };

        self.deleteDocument = function (formData, formFieldJson, successFn, errorFn) {
            var adaptedFormData = DocumentManagerAdaptorFactory.adeptDeleteRequest(formFieldJson);
            RemoteService.deleteDocument(adaptedFormData).then(
                function (response) {
                    successFn(response);
                }, function (error) {
                    errorFn(error);
                });
        };

        self.getFromatedCrewList = function(crewList){
            return DocumentManagerAdaptorFactory.formatCrew(crewList);
        };

        self.setSelectedDocInView = function(selectedDoc, docDetails){
        	var fileExtention = getFileType(docDetails.filePath);
        	var previewAvailable = showInPreview(docDetails.filePath);
            var blob = new Blob( [selectedDoc] , { 'type' : fileExtention ,  endings: 'native' });
            var url = $sce.trustAsResourceUrl((window.URL || window.webkitURL).createObjectURL( blob ));
            return {
                title: docDetails.title,
                summary: docDetails.summary,
                viewUrl: url,
                fileName : docDetails.filePath,
                previewAvailable : previewAvailable
            }
        };

        self.getDownloadDocument = function (doc, successFn, errorFn) {
            var params =  {
                downloadId: doc.downloadId,
                version : doc.version 
            };
            /*RemoteService.downloadDocument(params).then(
                    function (response) {
                        successFn(response);
                    }, function (error) {
                        errorFn(error);
                    });*/
            RemoteService.downloadDocumentFromServer(params,successFn, errorFn);
            
        };
        
        function getFileType(fileName){
        	
        	var fileExtention = fileName.substring(fileName.lastIndexOf(".") + 1 , fileName.length)
        	var applicationType = '' ;
        	
        	if (fileExtention.toUpperCase() === "TXT"){
    			applicationType = "text/plain";
    			
    		}else if(fileExtention.toUpperCase() === "PDF"){
    			applicationType = "application/pdf";
    			
    		}else if(fileExtention.toUpperCase() === "DOC"){
    			applicationType = "text/plain";
    			
    		}else if(fileExtention.toUpperCase() === "SQL"){
    			applicationType = "text/plain";
    			
    		}else if(fileExtention.toUpperCase() === "XML"){
    			applicationType = 'text/plain';
    			
    		}else{
    			applicationType = "application/octet-stream";
    		}
        	
        	return applicationType;
        }
        
        function showInPreview(fileName){
        	var fileExtention = fileName.substring(fileName.lastIndexOf(".") + 1 , fileName.length)
        	var previewAvailableExtentions = ['PDF','TXT','SQL','XML'];
        	var index = previewAvailableExtentions.indexOf(fileExtention.toUpperCase());
        	return index > -1 ? true : false;
        }
        
        
    }
})();